import React, { useEffect, useRef } from "react";
import type DyteClient from "@dytesdk/web-core";
import { DyteMeeting, provideDyteDesignSystem } from "@dytesdk/react-ui-kit";

// Inicializa o design system uma vez.
if (typeof document !== "undefined") {
  provideDyteDesignSystem(document.documentElement, { theme: "dark" });
}

interface DyteMeetProps {
  meeting: DyteClient;
  onMeetingEnd?: () => void;
}

const DyteMeet: React.FC<DyteMeetProps> = ({ meeting, onMeetingEnd }) => {
  const meetingEl = useRef<HTMLDyteMeetingElement>(null);

  useEffect(() => {
    const handleRoomLeft = ({ state }: any) => {
      if (state !== 'disconnected') {
        onMeetingEnd?.();
      }
    };

    // Adiciona o listener para o evento de saída da sala.
    meeting.self.on("roomLeft", handleRoomLeft);

    // Função de limpeza para remover o listener quando o componente for desmontado.
    return () => {
      // CORREÇÃO: Usar a mesma referência da função para remoção
      meeting.self.removeListener("roomLeft", handleRoomLeft);

      // SOLUÇÃO CRÍTICA: Remover listeners de stageStatusUpdate que causam memory leak
      if (meeting.stage && typeof meeting.stage.removeAllListeners === "function") {
        meeting.stage.removeAllListeners("stageStatusUpdate");
      }
    };
  }, [meeting, onMeetingEnd]);

  // Não precisamos mais de estados de 'loading' ou 'error' aqui,
  // pois o Room.tsx já cuida disso antes de renderizar este componente.
  return (
    <div className="h-full w-full relative">
      <DyteMeeting
        meeting={meeting}
        ref={meetingEl}
        showSetupScreen={false}
        className="w-full h-full"
        leaveOnUnmount={true}
        mode="fill"
      />
    </div>
  );
};

export default DyteMeet;
